import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    GetPunchoutIdentityApiParameter,
    getPunchoutIdentityCollection,
} from "@TKCCP/Services/PunchoutIdentityService";
import { PunchoutIdentityCollectionModel } from "@TKCCP/Types/ApiModels";

type HandlerType = ApiHandler<GetPunchoutIdentityApiParameter, PunchoutIdentityCollectionModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const DispatchBeginLoadPunchoutIdentityList: HandlerType = props => {
    props.dispatch({
        type: "Data/PunchoutIdentity/BeginLoadIdentities" as any,
        parameter: props.parameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getPunchoutIdentityCollection(props.apiParameter);
};
export const DispatchCompleteLoadPunchoutIdentityList: HandlerType = props => {
    props.dispatch({
        type: "Data/PunchoutIdentity/CompleteLoadIdentities" as any,
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadPunchoutIdentityList,
    RequestDataFromApi,
    DispatchCompleteLoadPunchoutIdentityList,
];

const loadPunchoutIdentityList = createHandlerChainRunner(chain, "loadPunchoutIdentityList");
export default loadPunchoutIdentityList;
